import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--performer"
export default class extends Controller {
  static outlets = ["drawer"];
  static targets = ["performerListBox", "checkbox", "performerForm"];

  connect() {
    if (this.hasPerformerListBoxTarget && this.hasCheckboxTarget) {
      const performerExists = !!document.querySelector('.selected-item[id^="selected_performer_"]');
      this.Visibility(performerExists);
    }
    if (this.hasCheckboxTarget) {
      this.deactivateSelectedPerformer();
    }
  }

  toggleVisibility() {
    if (!this.hasPerformerListBoxTarget) return;
    const anyChecked = this.checkboxTargets.some((checkbox) => checkbox.checked);

    this.Visibility(anyChecked);
  }

  Visibility(anyChecked) {
    if (anyChecked) {
      this.performerListBoxTarget.style.display = "";
    } else {
      this.performerListBoxTarget.style.display = "none";
    }
  }

  // drawer_controller.jsのcloseを呼び出す
  closeDrawer() {
    this.drawerOutlets.forEach((x) => x.close());
  }

  addForm() {
    const baseForm = document.getElementById("performer_input_name_form_base").innerHTML;
    const targetUl = document.getElementById("performer_input_name_form_list");
    targetUl.insertAdjacentHTML("beforeend", baseForm);
  }

  deleteForm(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const parentForm = button.closest("div[data-promoters--performer-target='form']");
    parentForm.remove();
  }

  addPerformer() {
    if (!this.hasPerformerListBoxTarget) return;

    const targetBox = document.getElementById("performer_list_box");
    const allInputs = targetBox.querySelectorAll('input[type="hidden"]');

    let checkboxes = document.querySelectorAll('input[name="performer_ids[]"]:checked');
    let targetForm;
    let alreadyAdded;

    checkboxes.forEach((checkbox) => {
      targetForm = document.getElementById("performer_input_form_" + checkbox.value).innerHTML;

      alreadyAdded = false;
      allInputs.forEach((input) => {
        if (input.value == checkbox.value) {
          alreadyAdded = true;
        }
      });

      if (!alreadyAdded) {
        targetBox.insertAdjacentHTML("beforeend", targetForm);
      }
    });

    this.toggleVisibility();

    this.closeDrawer();
  }

  deletePerformer(event) {
    event.preventDefault();

    const performerElement = event.currentTarget.parentNode;
    const hiddenInput = performerElement.querySelector('input[type="hidden"]');
    const performerId = hiddenInput ? hiddenInput.value : null;

    if (performerId) {
      const checkbox = document.querySelector(`input[type="checkbox"][id="performer_ids_${performerId}"]`);
      const hiddenInput = document.querySelector(`input[type="hidden"][id="selected_performer_${performerId}"]`);
      if (checkbox) {
        checkbox.checked = false;
        checkbox.disabled = false;
      }
      if (hiddenInput) {
        hiddenInput.remove();
      }
    }

    event.currentTarget.parentNode.remove();

    const performerExists = !!document.querySelector('.selected-item[id^="selected_performer_"]');
    this.Visibility(performerExists);
  }

  checkAll(event) {
    let checkboxes = document.querySelectorAll('input[name="performer_ids[]"]');

    checkboxes.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = event.currentTarget.checked;
      }
    });
    this.toggleVisibility();
  }

  performerDrawerSubmit(event) {
    event.preventDefault();
    this.deactivateSelectedPerformer();
    this.performerFormTarget.requestSubmit();
  }

  // 選択済みの出演者を非活性にする。
  deactivateSelectedPerformer() {
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.checked && !checkbox.disabled) {
        const hiddenInput = Object.assign(document.createElement("input"), {
          type: "hidden",
          id: `selected_performer_${checkbox.value}`,
          name: checkbox.name,
          value: checkbox.value,
        });
        this.performerFormTarget.appendChild(hiddenInput);
        checkbox.disabled = true;
      }
    });
  }
}
